<template>
  <div class="apply-form">
    <bCardHeader :param="param"></bCardHeader>
    <div
      class="apply-container"
      v-if="$route.query.includesUs === 'yes'"
    >
      <div class="mg-btm color-black">
        {{ $t("quotes.quotestips") }}
      </div>
      <p class="color-gray">
        {{ $t("quotes.quotesDomestic") }}
      </p>
      <el-radio
        v-model="checked"
        label="1"
      >{{
        $t(`quotes.domestic`)
      }}</el-radio>
      <el-radio
        v-model="checked"
        label="0"
      >{{
        $t(`quotes.unDomestic`)
      }}</el-radio>
      <el-form
        v-show="checked === '0'"
        ref="form"
        label-position="top"
        :model="form"
      >
        <p class="color-black">{{$t(`quotes.enterChange`)}}</p>
        <el-checkbox
          class="form-checkbox"
          v-model="agreement"
        ></el-checkbox>
        <el-form-item :label="$t(`quotes.formList.employment`)">
          <el-select
            @change="onSelectorChoose"
            v-model="employmentSituationContent"
            :placeholder="$t('common.please_select')"
          >
            <el-option
              v-for="item in employmentSituation"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-show="
            agreement && verifyText.includes(this.employmentSituationContent)
          "
          :label="$t(`quotes.formList.company`)"
        >
          <el-input
            v-model="form.company"
            :placeholder="this.$t(`quotes.formError.company`)"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="
            agreement && verifyText.includes(this.employmentSituationContent)
          "
          :label="$t(`quotes.formList.companyAddress`)"
        >
          <el-input
            v-model="form.companyAddress"
            :placeholder="this.$t(`quotes.formError.companyAddress`)"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="
            agreement && verifyText.includes(this.employmentSituationContent)
          "
          :label="$t(`quotes.formList.industry`)"
        >
          <el-input
            v-model="form.industry"
            :placeholder="this.$t(`quotes.formError.industry`)"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="
            agreement && verifyText.includes(this.employmentSituationContent)
          "
          :label="$t(`quotes.formList.occupation`)"
        >
          <el-input
            v-model="form.occupation"
            :placeholder="this.$t(`quotes.formError.occupation`)"
          ></el-input>
        </el-form-item>
        <p class="p-border-bottom"></p>
        <el-checkbox
          class="form-checkbox"
          v-model="residenceAgree"
        ></el-checkbox>
        <el-form-item :label="$t(`quotes.formList.residentialAddress`)">
          <el-input
            v-model="form.residentialAddress"
            :placeholder="this.$t(`quotes.formError.residentialAddress`)"
          ></el-input>
        </el-form-item>
        <br />
        <el-form-item
          v-show="residenceAgree"
          :label="this.$t(`quotes.formList.residentialAddressImg`)"
        >
          <bUploadImage
            ref="uploadImg"
            @handleRemove="deleteImageHandle"
            @uploadHandle="uploadHandle"
            business="bucketPackage"
          />
          <div class="tips">
            <div class="line1">
              {{ $t("quotes.addressTips.tips") }}
            </div>
            <div class="line2">
              {{ $t("quotes.addressTips.line1") }}<br />
              {{ $t("quotes.addressTips.line2") }}<br />
              {{ $t("quotes.addressTips.line3") }}<br />
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="quotes-apply-terms-page">
      <div class="content list-wrapper">
        <div class="content-word">
          <div class="terms">
            <div class="title">{{ terms.title }}</div>
            <!-- <div class="sub-title">{{ terms.subTitle }}</div> -->
            <div
              class="terms-content"
              v-html="terms.item"
            ></div>
            <br />
            <div class="agree-check">
              <el-checkbox
                v-model="agreeConf.checked"
                :disabled="agreeConf.disabled"
                :size="agreeConf.size"
              >{{ terms.subTitle }}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button
        :loading="submitbtnLoading"
        type="primary"
        :disabled="!agreeConf.checked"
        @click="clickHandle"
      >{{ btnText }}</el-button>
    </div>
        <!-- 获取申请码弹窗 -->
    <bDialog
      :dialogVisible.sync="dialogParams.IsCodeShow"
      :refresh="refresh"
      :closeModal="dialogParams.closeModal"
      :params="dialogParams"
      :component="dialogParams.componentDialog"
      :contiune="dialogParams.contiune"
      :showClose="dialogParams.showClose"
    />
  </div>

</template>
<script>
import quotesApplyTerms from './quotesApplyTerms'
import tradeRequest from '@/api/v2/trade.js'
import complete from '../fund-transfer/info-dialog.vue'
export default {
  props: {
    submitbtnLoading: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      residenceAgree: false,
      agreement: false,
      checked: '',
      employmentSituationContent: '',
      imageKeys: [],
      form: {
        residentialAddress: '',
        company: '',
        companyAddress: '',
        industry: '',
        occupation: ''
      },
      param: {
        title: 'quotes',
        links: [{ title: 'home' }, { title: 'my_account' }, { title: 'quotes' }]
      },
      needNext: false,
      needSecondNext: false,
      terms: {},
      btnText: '',
      agreeConf: {
        checked: false,
        name: 'agree0',
        size: 'md',
        disabled: false,
        introduction: '选中状态'
      },
      typeList: [],
      dialogParams: {
        IsCodeShow: false,
        closeModal: false,
        orderId: '',
        showClose: false, // 申请码关闭小图标
        contiune: true, // 申请码继续按钮
        componentDialog: complete // 申请码弹窗内容
      },
      stockItem: false,
      hkfuturesItem: false,
      futuresItem: false,
      isEddidPro: false
    }
  },
  computed: {
    verifyText () {
      return [
        this.$t('quotes.employmentSelector.Employment'),
        this.$t('quotes.employmentSelector.selfCare')
      ]
    },
    employmentTransfor () {
      return {
        [this.$t('quotes.employmentSelector.Employment')]: 'employed',
        [this.$t('quotes.employmentSelector.selfCare')]: 'self',
        [this.$t('quotes.employmentSelector.retirement')]: 'retired',
        [this.$t('quotes.employmentSelector.Unemployed')]: 'unemployed'
      }
    },
    employmentSituation () {
      return [
        {
          value: this.$t('quotes.employmentSelector.Employment'),
          label: this.$t('quotes.employmentSelector.Employment')
        },
        {
          value: this.$t('quotes.employmentSelector.selfCare'),
          label: this.$t('quotes.employmentSelector.selfCare')
        },
        {
          value: this.$t('quotes.employmentSelector.retirement'),
          label: this.$t('quotes.employmentSelector.retirement')
        },
        {
          value: this.$t('quotes.employmentSelector.Unemployed'),
          label: this.$t('quotes.employmentSelector.Unemployed')
        }
      ]
    }
  },
  mounted () {
    this.getContent()
  },
  methods: {
    onSelectorChoose (text) {
      this.employmentSituationContent = text
      this.agreement = true
      console.log(this.agreement)
    },
    deleteImageHandle (index, name) {
      this.imageKeys.splice(index, 1)
    },
    uploadHandle (imgKey) {
      this.imageKeys = imgKey
    },
    getContent () {
      this.typeList = this.$route.query.typeList || []
      let typeList = this.$route.query.typeList || []
      // 单个市场套餐
      if (typeList && typeList.length === 1) {
        this.needNext = false
        this.btnText = this.$t('quotes.submitApply')
        if (['HK_STOCK', 'HK_STOCK_INTERNATIONAL', 'US_STOCK'].includes(typeList[0])) {
          this.terms = this.$t('quotes.stockterms')
        } else if (['HK_FUTURES', 'HK_FUTURES_INTERNATIONAL'].includes(typeList[0])) {
          this.terms = this.$t('quotes.hkFeaturesTerms')
        } else if (['EDDID_PRO_BASIS', 'EDDID_PRO_ADVANCED'].includes(typeList[0])) {
          this.terms = this.$t('quotes.eddidPro')
        } else {
          this.terms = this.$t('quotes.featureTerms')
        }
      }
      if (typeList && typeList.length > 1) {
        // 混合市场套餐
        let stockItem = typeList.some(item => {
          return ['HK_STOCK', 'HK_STOCK_INTERNATIONAL', 'US_STOCK'].includes(
            item
          )
        })
        this.stockItem = stockItem
        let hkfuturesItem = typeList.some(item => {
          return ['HK_FUTURES', 'HK_FUTURES_INTERNATIONAL'].includes(
            item
          )
        })
        this.hkfuturesItem = hkfuturesItem
        let futuresItem = typeList.some(item => {
          return [
            'CHICAGO_FUTURES',
            'SINGAPORE_FUTURES'
          ].includes(item)
        })
        this.futuresItem = futuresItem
        // EddidPro
        this.isEddidPro = typeList.some(item => {
          return ['EDDID_PRO_BASIS', 'EDDID_PRO_ADVANCED'].includes(item)
        })
        // 有股票
        if (stockItem) {
          this.terms = this.$t('quotes.stockterms')
          // 只有股票
          if (!futuresItem && !hkfuturesItem) {
          this.btnText = this.$t('quotes.submitApply')
          this.needNext = false
          this.needSecondNext = false
          // 股票+全球期货 || 股票+港期
          } else if ((futuresItem && !hkfuturesItem) || (!futuresItem && hkfuturesItem)) {
            this.btnText = this.$t('quotes.nextStep')
            this.needNext = true
            this.needSecondNext = false
            // 股票+港期+全球期货
          } else if (futuresItem && hkfuturesItem) {
            this.btnText = this.$t('quotes.nextStep')
            this.needNext = true
            this.needSecondNext = true
          }
          // 有港期
        } else if (hkfuturesItem) {
          this.terms = this.$t('quotes.hkFeaturesTerms')
          this.needSecondNext = false
          // 港期+全球期货
          if (futuresItem) {
            this.btnText = this.$t('quotes.nextStep')
            this.needNext = true
          // 港期
          } else if (!futuresItem) {
            this.btnText = this.$t('quotes.submitApply')
            this.needNext = false
          }
        } else if (futuresItem) {
          // 只有全球期货
          this.terms = this.$t('quotes.featureTerms')
          this.btnText = this.$t('quotes.submitApply')
          this.needNext = false
          this.needSecondNext = false
        } else if (this.isEddidPro) {
          // 只有EddidPro
          this.terms = this.$t('quotes.eddidPro')
          this.btnText = this.$t('quotes.submitApply')
          this.needNext = false
          this.needSecondNext = false
        }
      }
    },
    clickHandle () {
      // 美股判断资料是否相同勾选
      if (this.typeList.includes('US_STOCK') && this.checked === '') {
        console.log('faaaaaaaaa')
        this.$message.error(this.$t('quotes.usErrorInfo'))
        return false
      }
      let updateClientInfo = {}
      if (this.checked === '0') {
        if (!this.residenceAgree && !this.agreement) {
          this.$message.error(this.$t('quotes.formError.agreeError'))
          return
        }
        if (this.agreement && this.employmentSituationContent === '') {
          this.$message.error(
            this.$t('quotes.formError.employmentSituationContent')
          )
          return
        }
        const keys = Object.keys(this.form)
        let index = -1
        if (
          this.agreement &&
          this.verifyText.includes(this.employmentSituationContent)
        ) {
          index = keys.findIndex(
            it => it !== 'residentialAddress' && this.form[it] === ''
          )
          if (index !== -1) {
            return this.$message.error(
              this.$t(`quotes.formError.${keys[index]}`)
            )
          }
        }
        if (this.residenceAgree) {
          index = keys.findIndex(it => this.form['residentialAddress'] === '')
          if (index !== -1) {
            return this.$message.error(
                          this.$t(`quotes.formError.residentialAddress`)
                        )
            }
          if (this.imageKeys.length === 0) {
              return this.$message.error(this.$t(`quotes.formError.imageKeys`))
            }
          }
        if (this.agreement) {
          updateClientInfo = {
            // eslint-disable-next-line standard/computed-property-even-spacing
            employment: this.employmentTransfor[this.employmentSituationContent]
          }
          if (this.verifyText.includes(this.employmentSituationContent)) {
            Object.assign(updateClientInfo, this.form, {
              companyName: this.form.company
            })
          }
        }
        if (this.residenceAgree) {
          Object.assign(updateClientInfo, {
            address: this.form.residentialAddress,
            addressProve: this.imageKeys
          })
        }
      } else {
        updateClientInfo = {}
      }
      if (this.needNext && !this.needSecondNext) {
        this.$route.query.includesUs = 'no'
        this.agreeConf.checked = false
        // 港期
        if (this.hkfuturesItem && !this.futuresItem) {
          this.terms = this.$t('quotes.hkFeaturesTerms')
          this.btnText = this.$t('quotes.submitApply')
          this.needNext = false
          return
        }
        // 全球期货 || 港期+全球期货
        if ((this.futuresItem && !this.hkfuturesItem) || (this.futuresItem && this.hkfuturesItem)) {
          this.terms = this.$t('quotes.featureTerms')
          this.btnText = this.$t('quotes.submitApply')
          this.needNext = false
          return
        }
        // 所有的都有的情况
      } else if (this.needNext && this.needSecondNext) {
        this.$route.query.includesUs = 'no'
        this.agreeConf.checked = false
        this.terms = this.$t('quotes.hkFeaturesTerms')
        this.btnText = this.$t('quotes.nextStep')
        this.needNext = true
        this.needSecondNext = false
        return
      }
      this.submitApply(updateClientInfo)

      console.log(updateClientInfo, 'updateClientInfo')
    },
    async submitApply (val) {
      try {
        let updateObj = val
        let quoteUpdateInformationCommand = updateObj.employment ? {
          'addressImages': updateObj.addressProve,
          'companyAddress': updateObj.companyAddress,
          'companyName': updateObj.company,
          'employmentType': updateObj.employment,
          'jobTitle': updateObj.occupation,
          'occupation': updateObj.industry,
          'residentialAddress': updateObj.address
        } : {}
        let params = {
          agreement: true,
          code: this.$route.query.code,
          submitSource: 'CP_WEB',
          subscribeNumber: 1,
          informationStatement: this.checked !== '0',
          'quoteUpdateInformationCommand': quoteUpdateInformationCommand
        }
        if (Object.keys(quoteUpdateInformationCommand).length === 0) {
          delete params.quoteUpdateInformationCommand
        }

        console.log(params, 'paramsparams')
        const result = await tradeRequest.commitQuoteService(params)
        let { orderId } = result.data
        this.dialogParams.orderId = orderId
        this.submitbtnLoading = false
        this.dialogParams.IsCodeShow = true
        return true
      } catch (err) {
        console.log('submitApply--err', err)
        this.$message.error('提交失败,请稍后再试')
        this.submitbtnLoading = false
        return false
      }
    },
    closeChange () {
      // this.$message.success('申请成功')
    },
    refresh () {
      this.$router.push({
          path: '/quotes'
        })
    }
  },
  components: {
    quotesApplyTerms
  }
}
</script>
<style lang="scss" scoped>
.apply-form {
  padding: 20px 30px;
  // background: #fff;
  .apply-container {
    padding: 20px 30px;
    background-color: #fff;
  }
  .form-checkbox {
    position: absolute;
    left: 0;
    margin-top: 6px;
  }
  .color-gray {
    color: #666;
  }
  .color-black {
    color: #000;
  }
  .mg-lf {
    margin-left: 45px;
  }
  .p-border-bottom {
    border: 1px solid #eee;
    margin: 0 0 25px 0;
  }

  /deep/ .el-button {
    width: 250px;
    height: 60px;
    font-size: 16px;
    margin-top: 30px;
  }
  /deep/ .el-radio {
    font-size: 20px;
  }
  /deep/ .el-radio__inner {
    width: 25px;
    height: 25px;
  }
  /deep/ .el-radio__label {
    font-size: 16px;
  }
  /deep/ .el-select {
    width: 100%;
  }
  /deep/ .el-form {
    position: relative;
    padding-left: 20px !important;
  }
  /deep/ .el-form-item {
    min-width: 280px;
    width: 46%;
    display: inline-block;
    margin-right: 2%;
  }
  .employmentSituationContent {
    display: initial;
  }
  .upload-image-title {
    color: #000;
  }
  .mg-btm {
    margin-bottom: 30px;
  }
  .tips {
    color: #7d7d7d;
    font-size: 12px;
    left: 337px;
    font-size: 12px;
    text-align: left;
    font-family: PingFangSC-Regular;
    .line2 {
      margin-top: 5px;
      padding-bottom: 20px;
      border-bottom: 2px solid #ebebeb;
    }
  }
}
.quotes-apply-terms-page {
  padding: 30px 0;
  background-color: #fff;
  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    top: 3px;
  }
  .list-wrapper {
    padding: 0 30px;
    .content-word {
      border-left: 4px solid #fec000;
      background: #f3f4f6;
      // margin-top: 30px;
      padding: 20px 0px 20px 20px;
      font-size: 14px;
      color: #666666;
    }
    /deep/ .el-checkbox__inner {
      width: 20px;
      height: 20px;
    }
    /deep/ .el-checkbox__label {
      font-size: 14px !important;
    }
    .terms-content {
      line-height: 20px;
      margin-bottom: 15px;
    }
    .terms {
      max-height: 400px;
      overflow-y: scroll;
      .title {
        font-weight: bold;
      }
      .sub-title {
        font-weight: bold;
      }
    }
  }
  .dialog-footer {
    padding: 0 30px 20px;
  }
}
</style>
